import { version as getUuidVersion, validate as validateUuid } from 'uuid';

export const isValidUuidV4 = (uuid: string): boolean => validateUuid(uuid) && getUuidVersion(uuid) === 4;
